var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hasRand)?_c('span',{staticClass:"text-view",attrs:{"name":_vm.k},domProps:{"innerHTML":_vm._s(_vm.t(_vm.k))}}):_c('span',{staticClass:"text-view",attrs:{"name":_vm.k}},[_c('count-to',{attrs:{"startVal":_vm.val,"endVal":_vm.newVal,"suffix":_vm.suffix,"duration":300}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }